import { CommunicationSizeComponent, ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import { AutoFillDoorTypeEnum } from '@inter-ikea-storageone/range-pax/src/api/components/AutofillSingleWallComponent';

/**
 * This function is used to set disabled options. It calculates both left and right
 * dropdowns. The parameter descriptions are described as if it is the left side dropdown
 * that is currently evaluated
 * @param value The width evaluated in the other side dropdown (right side)
 * @param width The value selected in the current left side dropdown
 * @param currentDepth The left side depth
 * @param otherDepth The right side depth
 * @returns true if the option should be disabled
 */
export const setDisabledOptions = (
  value: number,
  width: number,
  currentDepth: number,
  otherDepth: number,
  selectedDoorType: AutoFillDoorTypeEnum
): boolean => {
  if (currentDepth === 580 && otherDepth === 580) {
    if ((width === 860 || width === 1360) && (value === 860 || value === 1360)) {
      return true;
    }
  }
  if (currentDepth === 350 && otherDepth === 580) {
    if (selectedDoorType === AutoFillDoorTypeEnum.HINGED) {
      if (value === 1130 && (width === 860 || width === 1360)) {
        return true;
      } else if (width === 1130 && (value === 860 || value === 1360)) {
        return true;
      }
    } else if (width === 1130 && (value === 860 || value === 1360)) {
      return true;
    } else if ((width === 860 || width === 1360) && value === 1130) {
      return true;
    }
  }
  if (currentDepth === 580 && otherDepth === 350) {
    if (selectedDoorType === AutoFillDoorTypeEnum.HINGED) {
      if (width === 860 && (value === 880 || value === 1380)) {
        return true;
      } else if (width === 1130 && (value === 860 || value === 1110 || value === 1360)) {
        return true;
      }
    } else if (width === 1130 && (value === 860 || value === 1360)) {
      return true;
    } else if ((width === 860 || width === 1360) && value === 1130) {
      return true;
    }
  }
  if (currentDepth === 350 && otherDepth === 350) {
    if (selectedDoorType === AutoFillDoorTypeEnum.HINGED) {
      if (value === 1130 || width === 1130) {
        return true;
      }
    } else if (width === 1130 && value === 1130) {
      return true;
    }
  }
  return false;
};

export const supportsCornerFrames = (products: Product[]) => {
  return products.filter(p => p.type === ProductType.PAX_CORNER_SOLUTION_ASM).length > 0;
};

export const getMajorityFrameDepth = (coreApi: CoreApi): number => {
  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  if (frames.length === 0) {
    return 580;
  }

  const allDepths = frames
    .map(frame => {
      return frame.getComponent<CommunicationSizeComponent>(
        ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
      )?.size.depth;
    })
    .filter(d => d !== undefined) as number[];

  const allDepthsAreEqual = allDepths.every((depth, i, arr) => depth === arr[0]);

  return allDepthsAreEqual ? allDepths[0] : 580;
};
